import { fetchApi } from './client'
import type { LogEntry } from './types'

interface LogsResponse {
  logs: LogEntry[]
  total?: number
}

/**
 * Fetch logs for a run.
 *
 * Maps to GET /api/logs/:uploadId endpoint.
 */
export async function getLogs(fileId: string): Promise<LogEntry[]> {
  const response = await fetchApi<LogsResponse>(`/api/logs/${fileId}`)
  return response.logs || []
}
